import { memo } from 'react';
import MathText from '../MathText';

/**
 * Rendu CÔTÉ PROF d'une question "Relier" (aperçu exerciseur, modale de
 * prévisualisation, import, panneaux de résultats de session). L'espace élève ne
 * passe pas par ici mais par RelierEleve : on affiche donc le CORRIGÉ, chaque
 * source en regard de sa cible, comme QCMRenderer et TexteLibreRenderer montrent
 * la bonne réponse. Auparavant les cibles étaient mélangées pour imiter la vue
 * élève, et le prof relisait un exercice dont il ne voyait aucun appariement.
 *
 * @param {Array} pairs - Les paires [{ source, target }, ...]
 * @param {Array} ciblesLeurres - [{ target, code }, ...] cibles surnuméraires
 *   éventuelles : aucune source ne leur correspond. Listées à part, pour que le
 *   prof voie qu'elles sont volontaires et ne les cherche pas dans les paires.
 */
const RelierRenderer = memo(function RelierRenderer({ pairs, ciblesLeurres, light }) {
    if (!pairs || pairs.length === 0) return null;

    const caseSource = light
        ? 'border-gray-200 bg-white text-gray-700'
        : 'border-slate-600 bg-slate-700/50 text-slate-200';
    const caseCible = light
        ? 'border-emerald-300 bg-emerald-50 text-emerald-800'
        : 'border-emerald-500/50 bg-emerald-500/10 text-emerald-200';

    return (
        <div>
            {!light && <span className="text-[10px] font-semibold uppercase tracking-wider mb-2 block text-slate-400">Relier</span>}
            <div className="space-y-2">
                {pairs.map((p, i) => (
                    <div key={i} className="flex items-stretch gap-2">
                        <div className={`flex-1 px-3 py-2.5 rounded-xl border text-sm ${caseSource}`}>
                            <MathText>{p.source}</MathText>
                        </div>
                        <div className={`flex items-center px-1 text-sm ${light ? 'text-emerald-600' : 'text-emerald-300'}`}>
                            &rarr;
                        </div>
                        <div className={`flex-1 px-3 py-2.5 rounded-xl border text-sm font-medium ${caseCible}`}>
                            <MathText>{p.target}</MathText>
                        </div>
                    </div>
                ))}
            </div>

            {ciblesLeurres && ciblesLeurres.length > 0 && (
                <div className="mt-3">
                    <span className={`text-[10px] font-semibold uppercase tracking-wider block mb-1.5 ${light ? 'text-gray-400' : 'text-slate-400'}`}>
                        Cibles sans correspondance
                    </span>
                    <div className="flex flex-wrap gap-2">
                        {ciblesLeurres.map((l, i) => (
                            <span
                                key={i}
                                className={`px-3 py-1.5 rounded-lg border text-xs ${
                                    light ? 'border-gray-200 bg-gray-50 text-gray-500' : 'border-slate-600 bg-slate-800 text-slate-400'
                                }`}
                            >
                                <MathText>{l.target}</MathText>
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
});

export default RelierRenderer;
